import { render } from "./AuthInstruction.vue?vue&type=template&id=93a107d2"
import script from "./AuthInstruction.vue?vue&type=script&lang=js"
export * from "./AuthInstruction.vue?vue&type=script&lang=js"

import "./AuthInstruction.vue?vue&type=style&index=0&id=93a107d2&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__